import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import {
  choices,
  email,
  maxLength,
  minLength,
  minValue,
  number,
  regex,
  required,
  useRefresh,
} from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import useNotify from "../../unit/useNotify";

import CustomAccountNumberTextField from "../../unit/forms/CustomAccountNumberTextField";
import CustomSelectVerify from "../../unit/forms/CustomSelectVerify";

const validateFirstName = [required(), minLength(2), maxLength(15)];
const validateEmail = email();
const validateAge = [number(), minValue(18)];
const validateZipCode = regex(/^\d{5}$/, "Must be a valid Zip Code");
const validateGender = choices(
  ["m", "f", "nc"],
  "Please choose one of the values"
);

const CustomToNotifyDepositDialog = (props: any) => {
  const record = props.record;
  const appId = record?.id;
  const loan = record?.loan;
  const appAttrs = record?.attrs;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [accountType, setAccountType] = useState(
    record?.bank_user_deposit_account_info?.account_type
  );
  const [accountNumber, setAccountNumber] = useState(
    record?.bank_user_deposit_account_info?.account_number
  );
  const refresh = useRefresh();
  const handleSaveDeposit = async () => {
    const formJson = {
      account_type: accountType,
      account_number: accountNumber,
    };
    if (accountType == "" || accountType == null) {
      errorNotify("Please fill all the Account Type fields");
      return false;
    }
    if (accountNumber == "" || accountNumber == null) {
      errorNotify("Please fill all the Account Number fields");
      return false;
    }

    const reqUrl = `applications/actions/notify/deposit`;
    const response = await sendRequest(reqUrl, { id: appId, data: formJson });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Deposit Data saved successfully");
      refresh();
    } else {
      errorNotify(response?.message || "Data not saved!");
    }
  };

  const defautAccountTypeList: { label: any; value: any }[] = [];
  defautAccountTypeList.push({ label: "Select", value: "" });
  defautAccountTypeList.push({ label: "Checking", value: "checking" });
  defautAccountTypeList.push({ label: "Savings", value: "savings" });

  return (
    <>
      <Grid container>
        <Grid
          container
          sx={{
            position: "sticky",
            top: "25px",
            zIndex: 2,
            justifyContent: "flex-end",
            // backgroundColor: "#fff",
            pb: 1,
          }}
        >
          <Grid item>
            <CustomButtonSave
              type="submit"
              className="btn btn-primary"
              variant="contained"
              label="Save"
              onClick={handleSaveDeposit}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 2, pb: 2, pt: 2 }}>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle
                title="In-House Deposit Account Type"
                required
              />
            </Grid>
            <Grid item xs={5}>
              <CustomSelectVerify
                fullWidth={true}
                id="account_type"
                name="account_type"
                optionlist={defautAccountTypeList}
                required={true}
                variant="outlined"
                value={accountType != "" ? accountType : ""}
                onChange={(e) => {
                  setAccountType(e.target.value);
                }}
                helperText={"no"}
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle
                title="In-House Deposit Account Number"
                required
              />
              <Typography variant="body2">
                (Enter numeric value and "-" only)
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <CustomAccountNumberTextField
                id="account_number"
                name="account_number"
                variant="outlined"
                fullWidth={true}
                value={accountNumber}
                defaultValue={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
                required={true}
                helperText="no"
                className="numericText"
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </Grid>
        {/* save button */}
      </Grid>
    </>
  );
};

export default CustomToNotifyDepositDialog;
